
import React from 'react';
import { Theme } from '../types';
import { LOGO_URL_DARK_MODE, LOGO_URL_LIGHT_MODE } from '../constants';
import { SunIcon, MoonIcon, InfoIcon } from './icons';

interface HeaderProps {
  theme: Theme;
  onToggleTheme: () => void;
  onShowHelp: () => void;
}

const Header: React.FC<HeaderProps> = ({ theme, onToggleTheme, onShowHelp }) => {
  const logoUrl = theme === 'dark' ? LOGO_URL_DARK_MODE : LOGO_URL_LIGHT_MODE;
  const isDark = theme === 'dark';

  return (
    <header className={`p-4 shadow-md ${theme === 'dark' ? 'bg-hba-mid-purple' : 'bg-gray-100'}`}>
      <div className="container mx-auto flex justify-between items-center">
        <a 
          href="https://housebuenosaires.com/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center space-x-3 hover:opacity-80 transition-opacity"
          title="Ir a House Buenos Aires"
        >
          <img src={logoUrl} alt="HBA Eventos Logo" className="h-10 md:h-12" />
          <h1 className={`text-xl md:text-2xl font-semibold ${theme === 'dark' ? 'text-hba-text-primary' : 'text-gray-800'}`}>
            Mesa Planner
          </h1>
        </a>
        <div className="flex items-center space-x-3 md:space-x-4">
          <button
            onClick={onShowHelp}
            className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${
              theme === 'dark' 
                ? 'bg-hba-light-purple/50 hover:bg-hba-light-purple/80 text-hba-accent-pink' 
                : 'bg-purple-100 hover:bg-purple-200 text-hba-accent-purple'
            }`}
            aria-label="Mostrar ayuda e indicaciones"
          >
            <InfoIcon className="w-5 h-5" />
            <span className="text-sm font-medium">Ayuda</span>
          </button>
          
          {/* Theme Switch */}
          <button
            type="button"
            role="switch"
            aria-checked={isDark}
            onClick={onToggleTheme}
            className={`${
              isDark ? 'bg-hba-accent-purple focus:ring-hba-accent-pink' : 'bg-slate-200 focus:ring-hba-accent-purple'
            } relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-opacity-50`}
            aria-label={isDark ? "Activar modo claro" : "Activar modo oscuro"}
          >
            <span className="sr-only">Cambiar tema</span>
            <span
              className={`${
                isDark ? 'translate-x-6' : 'translate-x-1'
              } inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-200 ease-in-out flex items-center justify-center shadow`}
            >
              {isDark ? <MoonIcon className="w-3 h-3 text-hba-accent-purple" /> : <SunIcon className="w-3 h-3 text-hba-accent-purple" />}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
